var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wizard-body small-9 columns"},[_c('page-header',{attrs:{"header-title":_vm.$t('INBOX_MGMT.ADD.SMS.TITLE'),"header-content":_vm.$t('INBOX_MGMT.ADD.SMS.DESC')}}),_c('twilio',{attrs:{"type":"sms"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }